import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { ClusteringRadarChart } from './ClusteringRadarChart';
import { ClusterMetricMap } from './calculation';

interface ClusterMetricsDisplayProps {
    clusterId: number;
    metrics: ClusterMetricMap;
    features?: Record<string, number>;
    allClustersData: Record<number, Record<string, number>>;
    asset: string;
    showAllMetrics: boolean;
    radarChartSize?: number;
}

export const ClusterMetricsDisplay: React.FC<ClusterMetricsDisplayProps> = ({
    clusterId,
    metrics,
    features,
    allClustersData,
    asset,
    showAllMetrics,
    radarChartSize = 200
}) => {
    const basicMetrics = ['total_return', 'volatility', 'sharpe_ratio'];

    return (
        <>
            {/* Basic metrics (always visible) */}
            {basicMetrics.map((key) => {
                const value = metrics[key];
                if (value === undefined) return null;
                return (
                    <Box key={key} display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="caption" sx={{ textAlign: 'left' }}>
                            {key.replace(/_/g, ' ')}:
                        </Typography>
                        <Typography variant="caption" sx={{ textAlign: 'right', fontWeight: 500 }}>
                            {value.toFixed(4)}
                        </Typography>
                    </Box>
                );
            })}

            {showAllMetrics && (
                <Divider sx={{ my: 1 }} />
            )}

            {/* Additional metrics when expanded */}
            {showAllMetrics && Object.entries(metrics)
                .filter(([key]) => !basicMetrics.includes(key))
                .map(([key, value]) => (
                    <Box key={key} display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="caption" sx={{ textAlign: 'left' }}>
                            {key.replace(/_/g, ' ')}:
                        </Typography>
                        <Typography variant="caption" sx={{ textAlign: 'right', fontWeight: 500 }}>
                            {value.toFixed(4)}
                        </Typography>
                    </Box>
                ))}

            {/* Show radar chart only when all metrics are shown */}
            {showAllMetrics && features && (
                <>
                    <Divider sx={{ my: 1 }} />
                    <ClusteringRadarChart
                        data={features}
                        allClustersData={allClustersData}
                        asset={asset}
                        size={radarChartSize}
                    />
                </>
            )}
        </>
    );
};